module.exports = __webpack_public_path__ + "img/logo.c3a04119.png";